import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "lp-wave-content" }
const _hoisted_2 = { class: "lp-wave-login ly-row ly-center-center" }
const _hoisted_3 = { class: "ly-col ly-center-center forgot-password-container" }
const _hoisted_4 = { class: "card lp-load-fadein" }
const _hoisted_5 = {
  key: 2,
  class: "msg msg-error w-100 text-center"
}

import { ref, inject, Ref } from 'vue'
import NewResetPasswordForm from './components/NewResetPasswordForm.vue'
import ResetPasswordSuccessView from './components/ResetPasswordSuccessView.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'NewSetNewPasswordView',
  setup(__props) {

const errorMessage: Ref<string> = ref('')
const hasExpiredCode: Ref<boolean> = ref(false)
const submitting: Ref<boolean> = ref(false)
const username: Ref<string> = ref('')
const password: Ref<string> = ref('')
const showSuccessView: Ref<boolean> = ref(false)
const usernamePasswordLogin = inject('usernamePasswordLogin') as (username: string, password: string, selectedService: ServiceNames) => Promise<void>
const resetPassword = inject('resetPassword') as (username: string, password: string, code: string) => Promise<void>

const onResetPasswordFormSubmitted = async (params: { username: string, password: string, code: string }) => {
  if (submitting.value) return
  submitting.value = true

  resetPassword(params.username, params.password, params.code).then(() => {
    username.value = params.username
    password.value = params.password
    showSuccessView.value = true
    submitting.value = false
  }).catch((error: any) => {
    hasExpiredCode.value = error?.code === 'ExpiredCodeException'
    submitting.value = false

    displayError(error)
  })
}

const onAutoLoginTriggered = async (params: any) => {
  if (submitting.value) return
  submitting.value = true
  try {
    const appId = window.localStorage.getItem('appId') || 'LMS'
    await usernamePasswordLogin(username.value, password.value, appId)
  } catch (error: any) {
    displayError(error)
  }
  submitting.value = false
}

const displayError = (error: any) => {
  error.message
    ? errorMessage.value = error.message
    : errorMessage.value = 'Unexpected Error'
}

return (_ctx: any,_cache: any) => {
  const _directive_load_fade_in = _resolveDirective("load-fade-in")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_4, [
              (showSuccessView.value)
                ? (_openBlock(), _createBlock(ResetPasswordSuccessView, {
                    key: 0,
                    onLoginSubmitted: onAutoLoginTriggered
                  }))
                : (_openBlock(), _createBlock(NewResetPasswordForm, {
                    key: 1,
                    onFormSubmitted: onResetPasswordFormSubmitted,
                    onErrorCatched: displayError,
                    isSubmitting: submitting.value,
                    hasExpiredCode: hasExpiredCode.value
                  }, null, 8, ["isSubmitting", "hasExpiredCode"])),
              (errorMessage.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(errorMessage.value), 1))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, true]
            ])
          ]),
          _: 1
        })
      ])), [
        [_directive_load_fade_in, { delay: 1000, timeBetween: 500 }]
      ])
    ])
  ]))
}
}

})